import { defineLabels, resolveLabels } from "@nexus/widget-sdk";

export const TIMELINE_LABELS = defineLabels([
  { key: "emptyTitle", name: "Empty state title", default: "No events" },
  {
    key: "emptyDescription",
    name: "Empty state description",
    default: "No events match the selected tenants and time range.",
  },
  { key: "timelineView", name: "Timeline view button", default: "Timeline view" },
  { key: "listView", name: "List view button", default: "List view" },
  {
    key: "now",
    name: "Current time marker",
    default: "Now",
    hint: "Also used by the jump-to-now button.",
  },
  { key: "noEventsInWindow", name: "Empty window text", default: "No events in this window" },
  { key: "live", name: "Live caption in the list", default: "live" },
] as const);

export type EventTimelineLabels = ReturnType<typeof resolveLabels<typeof TIMELINE_LABELS>>;

export const DEFAULT_TIMELINE_LABELS: EventTimelineLabels = resolveLabels(
  TIMELINE_LABELS,
  undefined,
);
